/** config.interface */
// import { definitions } from '@/types/api';
import { CaseImpl } from './case.interface';

/** 学生端首页-卡片类型 */
export interface CardData {
  /** 封面图 */
  imgSrc: string;
  /** 标题 */
  title: string;
  /** 内容 */
  content: string;
  /** */
}

/** 首页案例卡片-操作类型需要的数据 */
export interface CardCaseData {
  /** 是否为解锁状态-可点击 */
  isUnLock: boolean;
  /** 状态列表 */
  statusList: string[];
  /** 案例信息 */
  caseInfo: CaseImpl;
}

/** 首页案例卡片-操作类型需要的数据 */
export interface CardResourceData extends Pick<CaseImpl, 'name'|'packageName'|'introduce'> {
  /** 是否为解锁状态-可点击 */
  isUnLock: boolean;
}
export class CardDataImpl implements CardData {
  imgSrc: string;

  title: string;

  content: string;

  caseData?: CardCaseData

  resourceData?: CardResourceData

  constructor(imgSrc: string, title: string, content: string, caseData: CardCaseData|undefined, resourceData: CardResourceData|undefined) {
    this.imgSrc = imgSrc;
    this.title = title;
    this.content = content;
    this.caseData = caseData;
    this.resourceData = resourceData;
  }
}

export type t = 't'
